import { useState, useEffect } from 'react';
import { PackageLimitsAPI, PackageUsageData } from '../api/package-limits';
import { useAuth } from '../contexts/AuthContext';

export function usePackageLimits() {
  const { workgroupEpoch } = useAuth();
  const [packageUsage, setPackageUsage] = useState<PackageUsageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPackageUsage = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await PackageLimitsAPI.getPackageUsage();
      if (response.data) {
        setPackageUsage(response.data);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch package usage';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackageUsage();
    // Re-fetch whenever the active workgroup changes so a workgroup switch
    // doesn't leave stale seat/quota data from the previous workgroup.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workgroupEpoch]);

  const refresh = () => {
    fetchPackageUsage();
  };

  return {
    packageUsage,
    loading,
    error,
    refresh,
  };
}
